import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemAttachmentsRoute: InvariantJiraRoute = {
	name: 'global-settings-system-attachments',
	path: '/secure/admin/ViewAttachmentSettings.jspa',
};
